import { createFileRoute, redirect } from '@tanstack/react-router'

import { isProfileTab } from '#pages/Profile/helpers'

interface IProfileSearch {
  tab?: string
}

export const Route = createFileRoute('/_authenticated/companies_/$companyId/users_/$userId/profile')({
  validateSearch: (search: Record<string, unknown>): IProfileSearch => ({
    tab: typeof search.tab === 'string' && isProfileTab(search.tab) ? search.tab : undefined,
  }),
  beforeLoad: ({ search, params }): void => {
    if (search.tab === undefined) return
    if (search.tab === 'card') 
      throw redirect({ to: '/companies/$companyId/users/$userId/card', params })
    
    if (search.tab === 'budget') 
      throw redirect({ to: '/companies/$companyId/users/$userId/budget', params })
    
    if (search.tab === 'settings') 
      throw redirect({ to: '/companies/$companyId/users/$userId/settings', params })
    
    throw redirect({ to: '/companies/$companyId/users/$userId/profile', params })
  },
})
